import createLucideIcon from '../createLucideIcon';

const MoveVertical = createLucideIcon('MoveVertical', [
  ['polyline', { points: '8 18 12 22 16 18', key: '1uutw3' }],
  ['polyline', { points: '8 6 12 2 16 6', key: 'd60sxy' }],
  ['line', { x1: '12', x2: '12', y1: '2', y2: '22', key: '7eqyqh' }],
]);

export default MoveVertical;
